import { iconFactory } from '../iconFactory'

export const Link = iconFactory(
  'Link',
  ({ fill }) => (
    <>
      <path
        d="M12.0833 4.66699H9.41659V6.00033H12.0833C13.1833 6.00033 14.0833 6.90033 14.0833 8.00033C14.0833 9.10033 13.1833 10.0003 12.0833 10.0003H9.41659V11.3337H12.0833C13.9233 11.3337 15.4166 9.84033 15.4166 8.00033C15.4166 6.16033 13.9233 4.66699 12.0833 4.66699ZM8.08325 10.0003H5.41659C4.31659 10.0003 3.41659 9.10033 3.41659 8.00033C3.41659 6.90033 4.31659 6.00033 5.41659 6.00033H8.08325V4.66699H5.41659C3.57659 4.66699 2.08325 6.16033 2.08325 8.00033C2.08325 9.84033 3.57659 11.3337 5.41659 11.3337H8.08325V10.0003ZM6.08325 7.33366H11.4166V8.66699H6.08325V7.33366Z"
        fill={fill}
      />
    </>
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
